import React, {useEffect, useState} from "react";

export const FiltersContext = React.createContext('');

export const FiltersProvider = ({value, children}) => {

    const [loading, setLoading] = useState(true);
    const [filtroKpi, setFiltroKpi] = useState({});

    const routesToKeepKpi = ['/list-kpi', '/info-kpi', '/upd-dati-kpi'];

    function initFiltroKpi() {
        setFiltroKpi({
            kpiSel: null,
            codice: '',
            descrizione: '',
            id_stato_kpi: '',
            stato_kpi: '',
            tipo_imp_dati: '',
            pagina: 1
        });
    }

    useEffect(() => {
        if (loading === true) {
            initFiltroKpi();
            setLoading(false)
        }
    }, []);


    function updateFiltroKpi(campo, valore) {
        setFiltroKpi(prevState => ({
            ...prevState,
            [campo]: valore
        }));
    }

    return (
        <FiltersContext.Provider
            value={{
                filtroKpi: filtroKpi,
                initFiltroKpi: initFiltroKpi,
                updateFiltroKpi,
                routesToKeepKpi: routesToKeepKpi,
            }}>{children}</FiltersContext.Provider>
    );
};
